import {
  type PropsWithChildren,
  createContext,
  useContext,
  useMemo,
  useState } from
"react";

export enum LoginStateEnum {
  LOGIN = 0,
  REGISTER = 1,
  RESET_PASSWORD = 2,
  MOBILE = 3,
  QR_CODE = 4,
}

interface LoginStateContextType {
  readonly loginState: LoginStateEnum;
  readonly setLoginState: (loginState: LoginStateEnum) => void;
  readonly backToLogin: () => void;
}
const LoginStateContext = createContext<LoginStateContextType>({
  loginState: LoginStateEnum.LOGIN,
  setLoginState: () => {},
  backToLogin: () => {}
});

export function useLoginStateContext() {
  const context = useContext(LoginStateContext);
  return context;
}

export function LoginStateProvider({ children }: Readonly<PropsWithChildren>) {
  const [loginState, setLoginState] = useState(LoginStateEnum.LOGIN);

  function backToLogin() {
    setLoginState(LoginStateEnum.LOGIN);
  }

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  const value: LoginStateContextType = useMemo(
    () => ({ loginState, setLoginState, backToLogin }),
    [loginState]
  );

  return (
    <LoginStateContext.Provider value={value}>
			{children}
		</LoginStateContext.Provider>);

}